import gql from 'graphql-tag';

const GET_TICKET_LIST = gql`
  query getTicketList($listInfo: ListInfoInput!, $isMSPProduct: Boolean!) {
    getTicketList(listInfo: $listInfo) {
      tickets {
        ticketId
        displayId
        subject
        priority
        category
        cause
        subcause
        createdTime
        firstResponseDueTime
        ticketType
        customFields
        dormantType
        operationalStatus
        status
        client @include(if: $isMSPProduct) {
          accountId
          name
        }
        department @skip(if: $isMSPProduct) {
          businessFunctionId
          name
        }
        requester {
          firstName
          lastName
          userId
          name
        }
        technician {
          userId
          firstName
          lastName
          email
          name
        }
        sla {
          name
          id
        }
        site {
          name
          id
        }
        createdTime
        source
        firstResponseDueTimeLeft
        resolutionDueTimeLeft
        resolutionDueTime
        resolutionViolated
        resolutionPauseTime
        resolutionTime
        totalTasks
        latestReply {
          type
          user {
            userId
            email
          }
        }
      }
      listInfo {
        view {
          id
        }
        page
        pageSize
        hasMore
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;
const GET_TICKET_LIST_CLASSIC = gql`
  query getTicketList($listInfo: ListInfoInput!, $isMSPProduct: Boolean!) {
    getTicketList(listInfo: $listInfo) {
      tickets {
        ticketId
        displayId
        subject
        priority
        category
        cause
        subcause
        createdTime
        firstResponseDueTime
        ticketType

        dormantType
        operationalStatus
        status
        client @include(if: $isMSPProduct) {
          accountId
          name
        }
        department @skip(if: $isMSPProduct) {
          businessFunctionId
          name
        }
        requester {
          firstName
          lastName
          userId
          name
        }
        technician {
          userId
          firstName
          lastName
          email
          name
        }
        sla {
          name
          id
        }
        site {
          name
          id
        }
        createdTime
        source
        firstResponseDueTimeLeft
        resolutionDueTimeLeft
        resolutionDueTime
        resolutionViolated
        resolutionPauseTime
        resolutionTime

        latestReply {
          type
          user {
            userId
            email
          }
        }
      }
      listInfo {
        view {
          id
        }
        page
        pageSize
        hasMore
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_TICKET_LIST_COUNT = gql`
  query getTicketList($listInfo: ListInfoInput!) {
    getTicketList(listInfo: $listInfo) {
      tickets {
        ticketId
      }
      listInfo {
        totalCount
      }
    }
  }
`;

const GET_ALL_CUSTOM_FIELDS = gql`
  query($module: String!) {
    getAllCustomFields(module: $module) {
      id
      columnName
      label
      description
      fieldType
      options
      showToClient
    }
  }
`;

const GET_DELETED_CUSTOM_FIELDS = gql`
  query($module: String!) {
    getDeletedCustomFields(module: $module) {
      id
      columnName
      label
      description
      fieldType
      options
      showToClient
    }
  }
`;

const GET_INACTIVE_FIELDS = gql`
  query getInactiveFields($input: String!) {
    getInactiveFields(input: $input) {
      id
      module
      entity {
        entityId
        name
      }
      columnName
      label
      description
      fieldType
      status
      options {
        id
        value
        order
        description
        details
        parentOption {
          id
          value
        }
        deletable
      }
      showToClient
      fieldCategory
      mandatoryOnCreate
      mandatoryOnClosure
      editable
      parentField {
        id
        module
        columnName
        fieldCategory
        label
        description
      }
    }
  }
`;

const GET_INACTIVE_FIELDS_FOR_TICKET = gql`
  query getInactiveFields($input: String!) {
    getInactiveFields(input: $input) {
      id
      module
      columnName
      label
      description
      fieldType
      showToClient
    }
  }
`;

const GET_DELETED_FIELDS = gql`
  query getDeletedFields($input: String!) {
    getDeletedFields(input: $input) {
      id
      columnName
      label
      description
      fieldType
      showToClient
    }
  }
`;

const GET_TICKET_ASSETS = gql`
  query getTicket($id: ID!) {
    getTicket(id: $id) {
      ticketId
      assets {
        assetId
        name
        assetClass {
          name
          classId
        }
      }
    }
  }
`;

const GET_TICKET = gql`
  query getTicket($id: ID!, $isMSPProduct: Boolean!) {
    getTicket(id: $id) {
      contractTicketMapping @include(if: $isMSPProduct) {
        contractId
        contract {
          name
          contractId
          billableContract {
            contractId
            chargeItem {
              itemId
              name
            }
          }
        }
        inUse
      }
      invoices @include(if: $isMSPProduct) {
        invoiceId
        displayId
        createdTime
      }
      workItem {
        workId
        subject
        module
        associations {
          workId
          subject
          module
        }
      }
      ticketId
      firstResponseDueTime
      firstResponseDueTimeLeft
      firstResponseTime
      firstResponseViolated
      resolutionDueTime
      resolutionPauseTime
      resolutionDueTimeLeft
      resolutionTime
      resolutionViolated
      firstResponseViolated
      status
      source
      subSource
      impact
      urgency
      priority
      category
      subcategory
      dormantType
      operationalStatus
      cause
      createdTime
      worklogTimerStarted
      worklogTimespent
      createdBy {
        userId
        firstName
        lastName
        name
        email
      }
      subcause
      resolutionCode
      totalTasks
      completedTasks
      techGroup {
        groupId
        name
      }
      technician {
        userId
        firstName
        lastName
        email
        name
      }
      followers {
        userId
        firstName
        lastName
        email
      }
      followers {
        userId
        firstName
        lastName
        email
        name
      }
      department @skip(if: $isMSPProduct) {
        businessFunctionId
        name
      }
      requester {
        userId
        firstName
        lastName
        name
        email
        forgotten
      }
      client @include(if: $isMSPProduct) {
        name
        accountId
        logoFileName
        primaryContact {
          phoneNumber
          contactNumber
        }
      }
      additionalRequester {
        userId
        firstName
        lastName
        email
        name
      }
      site {
        name
        id
        line1
        line2
        line3
        countryCode
        stateCode
        city
        postalCode
        contactNumber
      }
      displayId
      subject
      sop {
        sopId
        name
      }
      customFields
      assets {
        assetId
        name
      }
      sla {
        name
        id
      }
      ticketType
      form {
        formId
      }
      childTickets {
        ticketId
        displayId
      }
      parentTicket {
        ticketId
        displayId
        operationalStatus
      }
      aiAgentActionData {
        aiFeature {
          featureId
          constant
        }
        status
      }
    }
  }
`;

const GET_TICKET_REQUESTER = gql`
  query getTicket($id: ID!) {
    getTicket(id: $id) {
      ticketId
      requester {
        userId
        firstName
        lastName
        name
        email
        forgotten
      }
    }
  }
`;

const GET_CONVERSATION_FEEDS = gql`
  query getTicketFeeds($id: ID!) {
    getTicketFeeds(id: $id) {
      type
      conversation {
        conversationId
        content
        user {
          userId
          firstName
          lastName
          email
        }
        type
        time
        attachments {
          fileName
          originalFileName
          fileSize
        }
        toUsers {
          user {
            userId
            firstName
            lastName
            name
            email
          }
          mailDeliveryStatus
          mailFailureReason
        }
        ccUsers {
          user {
            userId
            firstName
            lastName
            name
            email
          }
          mailDeliveryStatus
          mailFailureReason
        }
        bccUsers {
          user {
            userId
            firstName
            lastName
            name
            email
          }
          mailDeliveryStatus
          mailFailureReason
        }
      }
      note {
        noteId
        content
        addedBy {
          userId
          firstName
          lastName
        }
        addedOn
        attachments {
          fileName
          originalFileName
          fileSize
        }
      }
      approval {
        approvalId
        approver {
          userId
          name
          firstName
          lastName
        }
        status
        comment
        sentOn
        actionTakenOn
      }
      task {
        taskId
        title
      }
    }
  }
`;

const GET_TICKET_AUDIT = gql`
  query getTicketAudit($input: TicketIdentifierInput!) {
    getTicketAudit(input: $input) {
      type
      time
      user {
        userId
        name
        firstName
        lastName
        email
      }
      conversation {
        conversationId
        content
        user {
          userId
          firstName
          lastName
          email
        }
        type
        time
        attachments {
          fileName
          originalFileName
          fileSize
        }
        toUsers {
          user {
            userId
            firstName
            lastName
            name
            email
          }
          mailDeliveryStatus
          mailFailureReason
        }
        ccUsers {
          user {
            userId
            firstName
            lastName
            name
            email
          }
          mailDeliveryStatus
          mailFailureReason
        }
        bccUsers {
          user {
            userId
            firstName
            lastName
            name
            email
          }
          mailDeliveryStatus
          mailFailureReason
        }
      }
      vendorConversation {
        type
        time
        user {
          userId
          firstName
          lastName
          email
        }
        conversationId
        parentConversationId
      }
      note {
        noteId
        content
        addedBy {
          userId
          firstName
          lastName
        }
        addedOn
        attachments {
          fileName
          originalFileName
          fileSize
        }
        privacyType
      }
      approval {
        approvalId
        approver {
          userId
          name
          firstName
          lastName
        }
        status
        comment
      }
      task {
        taskId
        title
      }
    }
  }
`;

const GET_SPLIT_TICKET_ATTRIBUTES = gql`
  query getTicketAttributesForSplitTicket {
    getTicketAttributesForSplitTicket
  }
`;

const GET_CUSTOM_FIELD_BY_NAME = gql`
  query getCustomFieldByName(
    $columnName: String!
    $module: String!
    $assetClassEntityName: String
  ) {
    getCustomFieldByName(
      columnName: $columnName
      module: $module
      assetClassEntityName: $assetClassEntityName
    ) {
      id
      columnName
      label
      description
      fieldType
      options
      showToClient
    }
  }
`;

const GET_STATUS_CONFIGURATION = gql`
  query getStatusConfiguration {
    getStatusConfiguration {
      configuration
      status {
        id
        name
        description
      }
    }
  }
`;

const GET_APPROVALS = gql`
  query getApprovals($listInfo: ListInfoInput!) {
    getApprovals(listInfo: $listInfo) {
      approvals {
        approvalId
        approver {
          userId
          name
          firstName
          lastName
        }
        status
        comment
        additionalMessage
        sentOn
        actionTakenOn
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
      }
    }
  }
`;

const GET_ALL_APPROVERS = gql`
  query($input: GetTicketApproverInput!) {
    getTicketApproverList(input: $input) {
      userList {
        userId
        firstName
        lastName
        name
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
      }
    }
  }
`;

const GET_ALL_APPROVAL_STATUS = gql`
  query getAllApprovalStatus {
    getAllApprovalStatus {
      approvalStatusId
      name
      state
    }
  }
`;

const GET_TICKET_TYPE = gql`
  query getAllTicketType {
    getAllTicketType {
      id
      name
      property
    }
  }
`;

const GET_UNKNOWN_EMAILS = gql`
  query getUnknownEmails($listInfo: ListInfoInput!) {
    getUnknownEmails(listInfo: $listInfo) {
      unknownEmails {
        unknownEmailId
        fromAddress
        subject
        messageId
        module
        receivedTime
        readStatus
        toRecipients
        ccRecipients
        meta
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_UNKNOWN_EMAIL = gql`
  query getUnknownEmail($unknownEmailId: ID!) {
    getUnknownEmail(unknownEmailId: $unknownEmailId) {
      unknownEmailId
      fromAddress
      subject
      messageId
      module
      receivedTime
      readStatus
      toRecipients
      ccRecipients
      meta
    }
  }
`;

const CONVERT_UNKNOWN_EMAIL_TO_CLIENT_CONVERSATION = gql`
  mutation($clientId: ID!, $unknownEmailId: ID!) {
    convertUnknownEmailToClientConversation(
      clientId: $clientId
      unknownEmailId: $unknownEmailId
    )
  }
`;

const CONVERT_UNKNOWN_EMAIL_TO_TICKET = gql`
  mutation(
    $clientId: ID!
    $unknownEmailIds: [ID!]!
    $siteId: ID
    $requesterInput: UserIdentifierInput
  ) {
    convertUnknownEmailsToTicket(
      clientId: $clientId
      unknownEmailIds: $unknownEmailIds
      siteId: $siteId
      requesterInput: $requesterInput
    )
  }
`;

const CONVERT_UNKNOWN_EMAIL_TO_TICKET_NEW = gql`
  mutation($input: ConvertUnknownTicketsInput!) {
    convertUnknownTickets(input: $input)
  }
`;

const DELETE_UNKNOWN_EMAILS = gql`
  mutation($unknownEmailIds: [ID!]!) {
    deleteUnknownEmails(unknownEmailIds: $unknownEmailIds)
  }
`;

const GET_ASSET_LIST = gql`
  query($listInfo: ListInfoInput!) {
    getWorkStationList(listInfo: $listInfo) {
      assets {
        assetId
        name
        client {
          name
        }
        site {
          name
        }
        owner {
          name
        }
        assetClass {
          name
          classId
        }
        ... on WorkStation {
          __typename
          serialNumber
          manufacturer
          model
          hostName
          primaryIp
          gateway
          platform
          domain
          status
          tag
          sysUptime
          teamViewerIntegrated
          splashtopIntegrated
          islIntegrated
          cwcIntegrated
          primaryMac
          assetAge
          serialKey
          biosVersion
          client {
            accountId
          }
          remoteDesktopEnabledStatus
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        hasMore
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_ASSET_LIST_FOR_DROPDOWN = gql`
  query($listInfo: ListInfoInput!) {
    getWorkStationList(listInfo: $listInfo) {
      assets {
        name
      }
    }
  }
`;

const GET_ASSET_LIST_COUNT = gql`
  query($listInfo: ListInfoInput!) {
    getWorkStationList(listInfo: $listInfo) {
      assets {
        assetId
      }
      listInfo {
        page
        pageSize
        totalCount
        hasMore
      }
    }
  }
`;

const IS_APPROVAL_PENDING = gql`
  query isLoggedInUserHasPendingApproval($ticketId: ID!) {
    isLoggedInUserHasPendingApproval(ticketId: $ticketId)
  }
`;

const GET_PUBLIC_APPROVAL = gql`
  query getPublicApproval($approvalId: ID!) {
    getPublicApproval(approvalId: $approvalId) {
      approvalId
      approver {
        userId
        name
      }
      status
      additionalMessage
      sentOn
      actionTakenOn
      ticket {
        ticketId
        displayId
        priority
        ticketType
        subject
        requester {
          userId
          name
        }
      }
    }
  }
`;

const GET_SOURCES = gql`
  query getAllSource {
    getAllSource {
      id
      name
    }
  }
`;

const GET_TICKET_SUMMARY = gql`
  query getTicketSummary($ticketId: ID!) {
    getTicketSummary(ticketId: $ticketId) {
      worklogCount
    }
  }
`;

const GET_TICKET_VIEW_COUNT = gql`
  query getTicketViewsCount($viewIds: [ID]) {
    getTicketViewsCount(viewIds: $viewIds) {
      viewId
      count
    }
  }
`;

const GET_TICKET_REPLY_RECIPEINTS = gql`
  query getTicketConversationReplyRecipients(
    $ticketInput: TicketIdentifierInput!
  ) {
    getTicketConversationReplyRecipients(input: $ticketInput) {
      to {
        userId
        name
        email
      }
      cc {
        userId
        name
        email
      }
      selectedMailbox {
        boxId
        outgoingAddress
        outgoingDomainVerified
      }
      mailboxes {
        boxId
        outgoingAddress
        outgoingDomainVerified
      }
      hasAdditionalRecipients
      conversationThreads {
        threadId
        conversationScope
        recipients {
          receiver {
            user {
              userId
              name
              email
            }
            referenceId
            label
            recipientType
          }
        }
      }
    }
  }
`;

const GET_ORIGINAL_MESSAGE = gql`
  query getTicketConversationThreadedContent(
    $input: GetConversationThreadedContentInput!
  ) {
    getTicketConversationThreadedContent(input: $input)
  }
`;

const GET_TICKET_SCHEDULE = gql`
  query getTicketSchedule(
    $input: TicketSchedulerIdentifierInput!
    $isMSPProduct: Boolean!
  ) {
    getTicketSchedule(input: $input) {
      scheduleId
      name
      description
      schedule
      form {
        formId
      }
      data {
        subject
        description
        ticketType
        client @include(if: $isMSPProduct) {
          accountId
        }
        requester {
          userId
          name
        }
        site {
          id
          name
        }
        department @skip(if: $isMSPProduct) {
          businessFunctionId
          name
        }
        techGroup {
          groupId
          name
        }
        technician {
          firstName
          lastName
          userId
        }
        attachments {
          fileName
          fileSize
          originalFileName
        }
        cause
        status
        impact
        urgency
        priority
        category
        subcause
        subcategory
        customFields
        resolutionCode
      }
      nextRunAt
    }
  }
`;

const GET_TICKET_SCHEDULES = gql`
  query getTicketSchedules($input: ListInfoInput!, $isMSPProduct: Boolean!) {
    getTicketSchedules(input: $input) {
      schedules {
        scheduleId
        name
        description
        schedule
        form {
          formId
        }
        data {
          subject
          description
          ticketType
          client @include(if: $isMSPProduct) {
            name
            accountId
          }
        }
        nextRunAt
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const RESTORE_REQUESTER_EMAILS = gql`
  mutation($input: RestoreRequesterEmailsInput!) {
    restoreRequesterEmails(input: $input)
  }
`;

const GET_DEFAULT_REPLY_TEMPLATE = gql`
  query getConversationContentFromReplyTemplate(
    $input: GetConversationContentFromReplyTemplateInput!
  ) {
    getConversationContentFromReplyTemplate(input: $input) {
      content
      attachments {
        fileName
        originalFileName
        fileSize
      }
    }
  }
`;

const GET_DEFAULT_SIDE_CONVERSATION_REPLY_TEMPLATE = gql`
  query getVendorConversationContentFromTemplate(
    $input: GetVendorConversationContentFromTemplateInput!
  ) {
    getVendorConversationContentFromTemplate(input: $input) {
      content
      subject
      toUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
      }
      ccUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
      }
      bccUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
      }
      attachments {
        fileName
        originalFileName
        fileSize
      }
    }
  }
`;

const GET_SECURE_FIELD_VALUE = gql`
  query getSecureFieldValue($input: SecureFieldValueInput!) {
    getSecureFieldValue(input: $input)
  }
`;

const GET_TICKET_AUDIT_LIST = gql`
  query getTicketAuditList($input: GetTicketAuditListInput!) {
    getTicketAuditList(input: $input) {
      ticketAudit {
        id
        type
        time
        user {
          userId
          name
          firstName
          lastName
          email
        }
        conversation {
          minifiedContent
          conversationId
          content
          user {
            userId
            firstName
            lastName
            email
          }
          type
          time
          outgoingMailStatus
          outgoingMailFailureReason
          attachments {
            fileName
            originalFileName
            fileSize
          }
          toUsers {
            user {
              userId
              firstName
              lastName
              name
              email
            }
            mailDeliveryStatus
            mailFailureReason
          }
          ccUsers {
            user {
              userId
              firstName
              lastName
              name
              email
            }
            mailDeliveryStatus
            mailFailureReason
          }
          bccUsers {
            user {
              userId
              firstName
              lastName
              name
              email
            }
            mailDeliveryStatus
            mailFailureReason
          }
        }
        threadConversation {
          conversationId
          content
          time
          attachments {
            fileName
            originalFileName
            fileSize
          }
          type
          conversationStatus
          failureReason
          conversationScope
          recipientDetails {
            user {
              userId
              firstName
              lastName
              name
              email
            }
            label
            conversationRecipientType
          }
        }
        conversationThread {
          threadId
          displayId
          status
          asset {
            assetId
            name
            assetClass {
              classId
              name
            }
          }
          recipients {
            initiator {
              user {
                userId
                name
              }
              referenceId
              name
            }
            receiver {
              user {
                userId
                name
              }
              referenceId
              name
            }
          }
        }
        vendorConversation {
          type
          time
          outgoingMailStatus
          outgoingMailFailureReason
          user {
            userId
            firstName
            lastName
            email
          }
          conversationId
          parentConversationId
        }
        note {
          noteId
          content
          addedBy {
            userId
            firstName
            lastName
          }
          addedOn
          attachments {
            fileName
            originalFileName
            fileSize
          }
          privacyType
        }
        approval {
          approvalId
          approver {
            userId
            name
            firstName
            lastName
          }
          status
          comment
        }
        task {
          taskId
          title
        }
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_CONVERSATION_TYPE_COUNT_LIST = gql`
  query getTicketAuditList($input: GetTicketAuditListInput!) {
    getTicketAuditList(input: $input) {
      ticketAudit {
        id
        type
        conversation {
          conversationId
          type
          time
        }
        note {
          noteId
          addedOn
        }
      }
    }
  }
`;

const GET_AUDIT_LOG_LIST = gql`
  query getTicketAuditLogList($input: GetAuditLogListInput!) {
    getTicketAuditLogList(input: $input) {
      audits {
        auditId
        entity
        operation
        time
        user {
          userId
          name
        }
        data
        entityId
        snapShot
        parentEntity
        parentEntityId
        actorId
        actorName
        actorLabel
      }
      listInfo {
        page
        hasMore
        pageSize
        condition
        cursor {
          type
          value
          attribute
        }
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_CLIENT_DATA = gql`
  query getClient($clientId: ID!) {
    getClient(clientId: $clientId) {
      accountId
      policyMigrationStatus
      name
      logoFileName
      primaryContact {
        phoneNumber
        contactNumber
      }
    }
  }
`;

const GET_EXPANDED_TICKET_CONVERSATION_CONTENT = gql`
  query getExpandedTicketConversationContent(
    $input: GetExpandedTicketConversationContentInput!
  ) {
    getExpandedTicketConversationContent(input: $input) {
      conversationId
      time
      subject
      user {
        userId
        firstName
        lastName
        email
        name
      }
      toUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
      }
      ccUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
        mailDeliveryStatus
        mailFailureReason
      }
      bccUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
        mailDeliveryStatus
        mailFailureReason
      }
      attachments {
        fileName
        originalFileName
        fileSize
      }
      content
    }
  }
`;

const GET_TICKET_META_FOR_BULK_UPDATE = gql`
  query getTicketMetaForBulkUpdate {
    getTicketMetaForBulkUpdate
  }
`;

const BATCH_UPDATE_TICKETS = gql`
  mutation batchUpdateTickets($input: BatchUpdateTicketsInput!) {
    batchUpdateTickets(input: $input) {
      ticketId
      displayId
      subject
      status
      priority
      technician {
        userId
        firstName
        lastName
        email
        name
      }
      techGroup {
        groupId
        name
      }
    }
  }
`;

export {
  GET_ALL_CUSTOM_FIELDS,
  GET_TICKET_LIST,
  GET_TICKET_LIST_CLASSIC,
  GET_TICKET,
  GET_CONVERSATION_FEEDS,
  GET_SPLIT_TICKET_ATTRIBUTES,
  GET_CUSTOM_FIELD_BY_NAME,
  GET_STATUS_CONFIGURATION,
  GET_APPROVALS,
  GET_ALL_APPROVERS,
  GET_ALL_APPROVAL_STATUS,
  GET_TICKET_TYPE,
  GET_UNKNOWN_EMAILS,
  GET_UNKNOWN_EMAIL,
  GET_ASSET_LIST,
  GET_TICKET_LIST_COUNT,
  GET_TICKET_ASSETS,
  IS_APPROVAL_PENDING,
  GET_PUBLIC_APPROVAL,
  GET_ASSET_LIST_COUNT,
  GET_DELETED_CUSTOM_FIELDS,
  GET_SOURCES,
  CONVERT_UNKNOWN_EMAIL_TO_CLIENT_CONVERSATION,
  DELETE_UNKNOWN_EMAILS,
  CONVERT_UNKNOWN_EMAIL_TO_TICKET,
  GET_TICKET_SUMMARY,
  GET_TICKET_VIEW_COUNT,
  GET_TICKET_REPLY_RECIPEINTS,
  GET_ORIGINAL_MESSAGE,
  GET_TICKET_SCHEDULES,
  GET_TICKET_SCHEDULE,
  RESTORE_REQUESTER_EMAILS,
  GET_TICKET_AUDIT,
  GET_DEFAULT_REPLY_TEMPLATE,
  GET_SECURE_FIELD_VALUE,
  GET_TICKET_AUDIT_LIST,
  GET_CONVERSATION_TYPE_COUNT_LIST,
  GET_AUDIT_LOG_LIST,
  GET_CLIENT_DATA,
  CONVERT_UNKNOWN_EMAIL_TO_TICKET_NEW,
  GET_ASSET_LIST_FOR_DROPDOWN,
  GET_DEFAULT_SIDE_CONVERSATION_REPLY_TEMPLATE,
  GET_EXPANDED_TICKET_CONVERSATION_CONTENT,
  GET_DELETED_FIELDS,
  GET_INACTIVE_FIELDS,
  GET_INACTIVE_FIELDS_FOR_TICKET,
  GET_TICKET_META_FOR_BULK_UPDATE,
  BATCH_UPDATE_TICKETS,
  GET_TICKET_REQUESTER
};
